import { z } from 'zod';

const password = z.string().min(8, 'Password must be at least 8 characters');

export const profileSchema = z.object({
  first_name: z.string().trim().min(1, 'First name is required'),
  last_name: z.string().trim().optional(),
  email: z.string().trim().toLowerCase().email('Enter a valid email'),
  mobile: z
    .object({
      country_code: z.string().min(1).max(5).optional(),
      calling_code: z.string().min(1).max(5).optional(),
      number: z
        .string()
        .trim()
        .min(6, 'Enter a valid phone number')
        .max(15, 'Enter a valid phone number')
        .optional(),
    })
    .optional(),
});

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: password,
    confirmPassword: z.string(),
  })
  .refine((d) => d.newPassword === d.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  })
  .refine((d) => d.currentPassword !== d.newPassword, {
    message: 'New password must differ from current',
    path: ['newPassword'],
  });
